import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Clapperboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Discreet admin entry point. Not linked anywhere public — visit /login directly.
// The backend still restricts sign-in to the admin account, so this is safe to keep.
export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (user) { navigate("/dashboard"); return; }
    login();
  }, [user, loading, login, navigate]);

  return (
    <div className="min-h-screen bg-zinc-950 text-white flex items-center justify-center" data-testid="admin-login">
      <div className="flex items-center gap-3 text-sm text-zinc-400">
        <Clapperboard size={20} className="text-rose-500" />
        Redirecting to secure sign-in…
      </div>
    </div>
  );
}
